<template>
    <div class="vm-action-lang" :class="[browser_size]">
      <div @click="tab_lang('zh-CN')" class="item flex-box flex-a-center flex-bet fs16 black-8 gl-hover-text">
          <span>简体中文</span>
          <i class="afd afd-arrow-right fs14 black-3"></i>
      </div>
      <div class="line mt20 mb20"></div>
      <div @click="tab_lang('en-US')" class="item flex-box flex-a-center flex-bet fs16 black-8 gl-hover-text">
          <span>English</span>
          <i class="afd afd-arrow-right fs14 black-3"></i>
      </div>
      <!-- <div class="line mt20 mb20"></div>
      <div class="item flex-box flex-a-center flex-bet fs16 black-8 gl-hover-text" @click="tab(2)">
          <span>日本語</span>
          <i class="afd afd-arrow-right fs14 black-3"></i>
      </div> -->
    </div>
</template>

<script>

import { mapState } from "vuex";
export default {
  name: "action-lang",
  props: {
    params: {},
  },
  data() {
    return {
        status:1
    };
  },
  inject:['app_action_sheet'],
  computed: {
    ...mapState("app", ["browser_size",'session_user','locale_lang']),
  },
  beforeDestroy(){
  },
  mounted() {
  },
  methods: {
    tab_lang(lang){
          // let lang = 
          // this.locale_lang
      // let lang = this.locale_lang == 'zh-CN' ? 'en-US' : 'zh-CN';
      this.$store.dispatch("app/set:locale_lang", lang);
      this.$i18n.locale = lang;
      this.app_action_sheet('close')
    },
  }
};
</script>

<style lang="stylus" scoped>
.vm-action-lang {
    background: $white;
    padding:24px 0px;
    box-sizing: border-box;
    width:350px;
    // transform:translate(0,100%);
    // transition:all .2s ease-out;
    // &.on{
    //     transform:translate(0,0);
    // }
    .line{
      background:#F7F7F7;
      margin-left:16px;
      margin-right:16px;
      width:calc(100% - 32px);
      box-sizing:border-box;
    }
    .item{
      padding:0 16px;
      margin-bottom:24px;
      &:last-child{
        margin-bottom:0px;
      }
    }
    &.small {
        min-width:auto;
        background: $white;
        border-radius:8px 8px 0 0;
        padding:24px 0 40px 0;
        position:fixed;
        left:0;
        width:100%;
        bottom:0;
    }
    &.safe-space{
      padding-bottom:$safe-space;
    }
}
</style>
